import {t} from 'react-multi-lang';

enum IShortlistable {
    Author,
    Title,
    Keyword,
    Year,
    Quote
}

export function shortlistableToString(shortlistable: any): string {
    switch (parseInt(shortlistable, 10)) {
        case IShortlistable.Quote: return t('evaluate.quote');
        case IShortlistable.Author: return t('evaluate.authors');
        case IShortlistable.Year: return t('evaluate.year');
        case IShortlistable.Keyword: return t('evaluate.keywords');
        case IShortlistable.Title: return t('evaluate.title');
        default:
            return '';
    }
}

export default IShortlistable;


// WEBPACK FOOTER //
// ./src/interfaces/IShortlistable.ts